import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  mapContainer: {
    borderRadius: "4px",
    height: "100%",
    width: "100%",
    "& div": {
      borderRadius: "8px !important",
    },
  },
}));

export default useStyles;
